import { type Infer, v } from "convex/values";

export const documentTypeValidator = v.union(
  v.literal("purchase_order"),
  v.literal("order_confirmation"),
  v.literal("invoice"),
  v.literal("bill_of_lading"),
  v.literal("proof_of_delivery"),
  v.literal("packing_slip"),
  v.literal("quote"),
  v.literal("statement"),
  v.literal("order"),
  v.literal("rfq"),
  v.literal("contract"),
  v.literal("certification"),
  v.literal("recycling_certificate"),
  v.literal("chain_of_custody"),
  v.literal("insurance"),
  v.literal("w9"),
  v.literal("spec_sheet"),
  v.literal("weight_ticket"),
  v.literal("customs_document"),
  v.literal("vendor_invoice"),
  v.literal("freight_invoice"),
  v.literal("buyer_purchase_order"),
  v.literal("credit_memo"),
  v.literal("remittance_advice"),
  v.literal("other"),
);
export const documentSequenceTypeValidator = documentTypeValidator;
export type DocumentType = Infer<typeof documentTypeValidator>;

export const documentStatusValidator = v.union(
  v.literal("generating"),
  v.literal("generated"),
  v.literal("uploaded"),
  v.literal("sent"),
  v.literal("synced"),
  v.literal("viewed"),
  v.literal("voided"),
  v.literal("failed"),
);
export type DocumentStatus = Infer<typeof documentStatusValidator>;
